import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";


export class Form {
  constructor(private $log: Logger, private $utils: Utils) {
    const forms: NodeListOf<HTMLFormElement> = document.querySelectorAll('form[name="ercas_form"]');

    forms?.forEach((form) => {
      this.initForm(form);
    });
  }

  public initForm(form: HTMLFormElement) {
    let formElements = Array.from(form.elements) as Array<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>;

    form.addEventListener('submit', (event: Event) => {
      if (form.reportValidity()) {
        return;
      }

      formElements = Array.from(form.elements) as Array<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>;

      formElements?.forEach(formElement => {
        if (formElement instanceof HTMLButtonElement || formElement instanceof HTMLFieldSetElement || formElement?.disabled) {
          return;
        }

        const container: HTMLElement = formElement.closest('[data-container]');
        const errorElement: HTMLElement = container?.querySelector('.js-error');
        const errorOutput: HTMLElement = errorElement?.querySelector('[data-output]') ?? errorElement;

        if (formElement.checkValidity()) {
          this.$utils.addOrRemoveClases('add', 'd-none', errorElement);
          this.$utils.addOrRemoveClases('remove', 'error', container);

          return;
        }

        this.$utils.addOrRemoveClases('remove', 'd-none', errorElement);
        this.$utils.addOrRemoveClases('add', 'error', container);

        const errorMessage = formElement.validationMessage;

        if (errorOutput) {
          errorOutput.innerHTML = errorMessage;
        }
      });

      event.preventDefault();
    });

    formElements?.forEach(formElement => {
      const container: HTMLElement = formElement.closest('[data-container]');
      const errorElement: HTMLElement = container?.querySelector('.js-error');
      const errorOutput: HTMLElement = errorElement?.querySelector('[data-output]') ?? errorElement;

      formElement.addEventListener('change', () => {
        if (formElement.checkValidity()) {
          this.$utils.addOrRemoveClases('add', 'd-none', errorElement);
          this.$utils.addOrRemoveClases('remove', 'error', container);

          return;
        }

        this.$utils.addOrRemoveClases('remove', 'd-none', errorElement);
        this.$utils.addOrRemoveClases('add', 'error', container);

        const errorMessage = formElement.validationMessage;

        if (!errorOutput?.innerHTML) {
          errorOutput.innerHTML = errorMessage;
        }
      });
    });
  }
}
